<div class="loader-container" [ngClass]="{ 'overlay-loader': isOverlay }">
  <img class="loader-gif" src="assets/final-GIF.gif" alt="Loading" />
  <span>{{ message }}</span>
</div>
